import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageContainer from '~/components/@sibill-components/shared/layout/PageContainer';
import Page from '~/components/Page';
import Button from '~/components/buttons/NewButton';
import AlertMessage from '~/components/data-display/AlertMessage';
import { VStack } from '~/components/layout/Stack';
import { AnalyticsContext } from '~/hooks/useAnalyticsContext';
import PlusIcon from '~/icons/icon-plus.svg?react';
import { RouteConfig } from '~/routes/routeConfig';
import { TableSortingProvider } from '~/state/tableSorting';
import { BookkeepingTransactionSorting } from '~/types/general-bookkeeping';
import { SortInfo } from '~/utils/jsonapi-query';
import GeneralBookkeepingTabs from '~/views/bookkeeping/GeneralBookkeepingTabs';
import SingleRegistrationAside from '~/views/bookkeeping/RegistrationAside/SingleRegistrationAside';
import ExportGeneralJournalPDFButton from '~/views/bookkeeping/cash-book/ExportGeneralJournalPDFButton';
import GeneralBookkeepingCashBookTable from '~/views/bookkeeping/cash-book/GeneralBookkeepingCashBookTable';
import { useDateFilter } from '~/views/bookkeeping/cash-book/cash-book-state';
import styles from './GeneralBookkeepingCashBook.module.scss';

const CASH_BOOK_SORTING_STORAGE_KEY = 'bookkeeping-cash-book-sorting';
const cashBookDefaultSorting: SortInfo<BookkeepingTransactionSorting> = { sort: 'date', direction: 'desc' };

const GeneralBookkeepingCashBook: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('bookkeeping', { keyPrefix: 'general_bookkeeping.cash_book' });
  const { t: tTransactions } = useTranslation('bookkeeping');
  const [dateRange] = useDateFilter();
  const onNewRegistrationClick = () => {
    navigate(RouteConfig.BookkeepingNewManualRegistration.buildLink());
  };

  return (
    <Page title={t('title')}>
      <TableSortingProvider storageKey={CASH_BOOK_SORTING_STORAGE_KEY} defaultSorting={cashBookDefaultSorting}>
        <PageContainer className={styles.container}>
          <VStack gap={2}>
            <GeneralBookkeepingTabs>
              <ExportGeneralJournalPDFButton />
              <Button onClick={onNewRegistrationClick} Icon={PlusIcon}>
                {tTransactions('transactions.create_transaction')}
              </Button>
            </GeneralBookkeepingTabs>

            {!dateRange && (
              <AlertMessage type="warning" box className={styles.exportHint}>
                {t('missing_date_range_hint')}
              </AlertMessage>
            )}
          </VStack>
          <GeneralBookkeepingCashBookTable />
        </PageContainer>
      </TableSortingProvider>
      <AnalyticsContext context="/single_registration_aside">
        <SingleRegistrationAside />
      </AnalyticsContext>
    </Page>
  );
};

export default GeneralBookkeepingCashBook;
